<template>
  <div class="py-2">
    <b-container fluid class="col-8 border-secondary mx-auto border__div px-0 pt-0 pb-4 mb-2">
      <b-overlay :show="loading" rounded="sm" spinner-variant="secondary">
        <div class="col-10 mx-auto" v-if="!msg">
          <b-form @submit="onSubmit">
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Nome:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  v-model="user.anagrafica.nome"
                  type="text"
                  id="nome"
                  :placeholder="user.anagrafica.nome"
                  class="my-2"
                  :disabled="disable"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row class="my-1 justify-content-around">
              <b-col sm="4" class="align-self-center text-left text-secondary">
                <label for="nome" class="text-right">Nome:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  v-model="user.anagrafica.cognome"
                  type="text"
                  id="cognome"
                  :placeholder="user.anagrafica.cognome"
                  class="my-2"
                  :disabled="disable"
                ></b-form-input>
              </b-col>
            </b-row>

            <p v-if="error" class="text-danger">{{error}}</p>

            <span
              class="text-secondary edit__link pt-3"
              v-if="this.disable"
              @click="toggleEdit"
            >Modifica</span>
            <div v-else>
              <b-button
                type="button"
                variant="outline-primary font-weight-bold mx-2"
                @click="toggleEdit"
              >Annulla</b-button>
              <b-button type="submit" variant="primary font-weight-bold mx-2">Salva</b-button>
            </div>
          </b-form>
        </div>
        <p v-else>{{msg}}</p>
      </b-overlay>
    </b-container>
  </div>
</template>

<script>
export default {
  name: "anagrafica-admin",
  props: ["utente"],
  components: {
    //
  },
  data() {
    return {
      user: this.utente,
      disable: true,
      msg: null,
      error: false,
      loading: false
    };
  },
  watch: {},
  computed: {
    //
  },
  methods: {
    toggleEdit(e) {
      e.preventDefault();
      console.log("clck");
      this.disable = !this.disable;
    },
    onSubmit(evt) {
      evt.preventDefault();
      !this.validate() && this.sendForm();
    },
    validate() {
      var check = Object.keys(this.user.anagrafica).some(val => {
        val != "cellulare" && this.user.anagrafica[val] == null;
      });
      if (check) {
        this.error = "nessun campo può essere vuoto";
      }
      return check;
    },
    sendForm() {
      this.loading = true;
      var url = process.env.VUE_APP_VERSION + this.user.role;
      this.$axios
        .put(url, this.user.anagrafica)
        .then(() => {
          this.loading = false;
          this.msg = "Operazione effettuata con successo!";
          var self = this;
          setInterval(function() {
            self.$router.go();
          }, 1000);
        })
        .catch(err => {
          this.error = err.response;
          this.loading = false;
        });
    }
  },
  created() {}
};
</script>
